var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:({ transform: 'rotate('+ _vm.transform + 'deg)' }),attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 10 6"}},[_c('path',{attrs:{"d":"M5 6L4.54116e-07 -5.12573e-07L10 -1.43051e-06L5 6Z","fill":"#3389FD"}})])}
var staticRenderFns = []

export { render, staticRenderFns }